import { Flex, Text } from "@chakra-ui/react";

export const InfoTrocas = ({ label, value }) => {
  return (
    <>
      <Flex align="center" gap={2}>
        <Text fontSize={["1rem"]} color={["#378BBF"]}>
          {label}:
        </Text>{" "}
        <Text fontSize={["1rem"]}>
          {value ? (
            value
          ) : (
            <Text size="xs" color="gray.400">
              Loading...
            </Text>
          )}
        </Text>
      </Flex>
    </>
  );
};
